import { Card, CardContent, CardHeader, CardTitle } from "@bcc/components/ui/card";
import type { PurchaseOrder } from "@shared/types";
import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { CROSS_BORDER_ERROR_STATUSES } from "./cross-border-constants";

interface CrossBorderErrorAlertsProps {
  readonly orders: PurchaseOrder[];
  readonly testId?: string;
}

export function CrossBorderErrorAlerts({ orders, testId }: CrossBorderErrorAlertsProps) {
  const { t } = useTranslation();

  const errorOrders = orders.filter((order) => order.orderStatus && CROSS_BORDER_ERROR_STATUSES.has(order.orderStatus));

  if (errorOrders.length === 0) return null;

  return (
    <Card className="border-destructive/50" data-testid={testId}>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-destructive">
          <AlertTriangle className="h-5 w-5" />
          {t("admin.crossBorder.errors.title")} ({errorOrders.length})
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2 max-h-64 overflow-y-auto">
          {errorOrders.map((order) => (
            <div
              key={order.purchaseOrderId}
              className="flex items-center justify-between rounded-lg border border-destructive/20 bg-destructive/5 px-3 py-2"
            >
              <div>
                <span className="font-mono text-sm font-medium">{order.purchaseOrderId}</span>
                <span className="ml-2 text-xs text-muted-foreground">{order.orderStatus}</span>
              </div>
              <span className="text-xs text-muted-foreground">{new Date(order.createdAt).toLocaleDateString()}</span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
